module.exports = __webpack_public_path__ + "static/media/instagram.17654b78.png";